export const isAgentInitiator = <T extends { __typename?: string }>(
  initiator: T | null | undefined,
): initiator is Extract<T, { __typename: 'AgentInitiator' }> =>
  initiator?.__typename === 'AgentInitiator';
